import { Badge } from "@/components/ui/badge";
import { STATUS_COLORS } from "@/lib/helpers";

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-[#1A1A1A]">{title}</h1>
        {subtitle && <p className="text-sm text-[#8A8A8A] mt-1">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2 flex-wrap">{children}</div>}
    </div>
  );
}

export function StatusBadge({ status }) {
  const cls = STATUS_COLORS[status] || "bg-[#F2EBE1] text-[#8A6D2F]";
  return (
    <Badge className={`${cls} border-0 font-medium capitalize`} data-testid={`status-${status}`}>{status}</Badge>
  );
}

export function EmptyState({ label = "No records found" }) {
  return <div className="text-center py-12 text-[#8A8A8A] text-sm" data-testid="empty-state">{label}</div>;
}
